import React, { useState } from 'react';
// import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Signup.css';
import { ArrowLeft } from 'react-bootstrap-icons';
import emailjs from 'emailjs-com';


function Signup() {
  const [email, setEmail] = useState('');
  const [hasAcceptedCGU, setHasAcceptedCGU] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const navigate = useNavigate();


  const handleSignup = (e) => {
    e.preventDefault();
    setErrorMsg('');
    setSuccessMsg('');

    if (!hasAcceptedCGU) {
      setErrorMsg("You must accept the Terms and Conditions.");
      return;
    }

    const templateParams = {
      user_name: name,
      user_email: email,
      message: message,
    };

    emailjs.send(
      "service_7zo14kc",      // le Service ID EmailJS
      "template_b3pkpse", // le Template ID EmailJS
      templateParams,
      "5QdZNHAb6dW-R5Bny"     // le Public Key EmailJS
    )
    .then(() => {
      setSuccessMsg("Your request has been sent successfully. You will receive an email when your account is created.");
      setTimeout(() => {
        navigate('/'); // redirection vers login
      }, 3000);
    })
    .catch((err) => {
      console.error(err);
      setErrorMsg("Error while sending request. Please try again later.");
    });
  };




  const handleTermsClick = (e) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  const handleCloseTerms = () => {
    setShowTermsModal(false);
  };

  const handleInvalidField = (e) => {
    const field = e.target;
    switch (field.id) {
      case 'name':
        field.setCustomValidity('Please enter your name');
        break;
      case 'email':
        field.setCustomValidity('Please enter a valid email address');
        break;
      case 'message':
        field.setCustomValidity('Please enter your message');
        break;
      default:
        field.setCustomValidity('This field is required');
    }
  };





  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '50px' }}>

      <div className="return-button">
        <button onClick={() => navigate('/')}>
          <ArrowLeft style={{ fontSize: '35px' }}></ArrowLeft>
        </button>
      </div>

      <h2 className="mb-4">Account creation request</h2>

      {errorMsg && <div className="alert alert-danger">{errorMsg}</div>}
      {successMsg && <div className="alert alert-success">{successMsg}</div>}




      <form onSubmit={handleSignup}>

        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              e.target.setCustomValidity('');
            }}
            onInvalid={handleInvalidField}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="yourname@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              e.target.setCustomValidity('');
            }}
            onInvalid={handleInvalidField}
            required
          />
        </div>

        {/* <div className="mb-3">
          <label htmlFor="password" className="form-label">
            Password
          </label>
          <input
            type="password"
            className="form-control"
            id="password"
            placeholder="Your secure password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div> */}

        <div className="mb-3">
          <label htmlFor="message" className="form-label">
            Message
          </label>
          <textarea
            className="form-control"
            id="message"
            placeholder="Please describe your research context and how you plan to use ACCADIL..."
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              e.target.setCustomValidity('');
            }}
            onInvalid={handleInvalidField}
            required
            rows={6}
            style={{ minHeight: '200px' }}
          />
        </div>


        <div className="mb-3 form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="cgu"
            checked={hasAcceptedCGU}
            onChange={(e) => setHasAcceptedCGU(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="cgu">
            I accept the <a href="#" onClick={handleTermsClick}>Terms and Conditions</a>
            {/* {!hasReadTerms && (
            <small className="text-danger d-block">
              Please read the Terms and Conditions first
            </small>
            )} */}
          </label>
        </div>

        <button type="submit" className="btn btn-success w-100" disabled={!hasAcceptedCGU}>
          Submit Request
        </button>
      </form>

      {/* Modal pour les Terms and Conditions */}

      {showTermsModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" style={{ maxWidth: '800px' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Terms and Conditions</h5>
                {/* <button type="button" className="btn-close" onClick={() => setShowTermsModal(false)}></button> */}
                <button type="button" className="btn-close" onClick={handleCloseTerms}></button>
              </div>    
            <div className="modal-body" style={{ 
              textAlign: 'justify', 
              padding: '30px',
              fontSize: '1.1em',
              lineHeight: '1.6'
            }}>
              {/* <h4>ACCADIL : Conditions Générales d'Utilisation</h4>
              
              <h5>1. Objet</h5>
              <p>L'application mise à disposition permet aux utilisateurs de déposer des images de monnaies
              afin d'évaluer automatiquement les probabilités de liaisons de coins monétaires grâce à des
              algorithmes de vision par ordinateur et d'intelligence artificielle.</p>

              <h5>2. Inscription</h5>
              <p>L'accès à l'application est soumis à une inscription gratuite. L'utilisateur doit fournir :</p>
              <ul>
                <li>Un nom (ou pseudonyme),</li>
                <li>Une adresse e-mail valide,</li>
                <li>Un message à destination des gestionnaires de l'application (qui procèderont à
                l'inscription effective),</li>
                <li>Et accepter les présentes conditions générales d'utilisation.</li>
              </ul>

              <h5>3. Utilisation des images déposées</h5>
              <p>En déposant des images de monnaies via l'application, l'utilisateur :</p>
              <ul>
                <li>Garantit être titulaire des droits d'utilisation des images ou avoir l'autorisation
                nécessaire pour les partager,</li>
                <li>Autorise expressément l'équipe de développement de l'application à utiliser ces
                images dans le cadre :
                  <ul>
                    <li>du fonctionnement de l'application et du calcul automatisé des liaisons de
                    coins monétaires,</li>
                    <li>de publications scientifiques ou communications académiques portant sur les
                    algorithmes de vision par ordinateur ou d'intelligence artificielle appliqués à la
                    numismatique.</li>
                  </ul>
                </li>
              </ul>

              <p>Aucune utilisation à des fins commerciales ne sera faite des images déposées.<br/>
              Les images ne seront pas revendues, ni utilisées pour des campagnes publicitaires, ni
              communiquées à des tiers à des fins lucratives.</p>

              <h5>4. Respect de la vie privée</h5>
              <p>Les données personnelles collectées (nom, e-mail, message) sont utilisées uniquement dans
              le cadre du fonctionnement de l'application, pour pouvoir éventuellement répondre aux
              utilisateurs ou assurer la modération. Aucune information personnelle ne sera transmise à
              des tiers sans le consentement explicite de l'utilisateur. Chaque utilisateur pourra faire
              supprimer son compte sur simple demande.</p>

              <h5>5. Responsabilités</h5>
              <p>L'application est proposée gratuitement et en l'état, sans garantie d'exactitude absolue des
              résultats. Les utilisateurs reconnaissent utiliser l'application sous leur propre responsabilité.</p>

              <h5>6. Droit applicable</h5>
              <p>Cette application étant développée et gérée depuis la France, toute question liée à son
              utilisation sera traitée selon le droit français. En cas de désaccord, une solution amiable sera
              toujours recherchée en priorité.</p> */}
              <h4>ACCADIL: General Terms and Conditions of Use</h4>
  
              <h5>1. Purpose</h5>
              <p>The application provided allows users to upload coin images to automatically evaluate 
              the probabilities of die links using computer vision algorithms and artificial intelligence.</p>

              <h5>2. Registration</h5>
              <p>Access to the application requires free registration. Users must provide:</p>
              <ul>
                <li>A name (or pseudonym),</li>
                <li>A valid email address,</li>
                <li>A message for the application administrators (who will process the registration),</li>
                <li>And accept these general terms and conditions of use.</li>
              </ul>

              <h5>3. Use of Uploaded Images</h5>
              <p>By uploading coin images through the application, the user:</p>
              <ul>
                <li>Guarantees that they own the rights to use the images or have the necessary 
                authorization to share them,</li>
                <li>Expressly authorizes the application development team to use these images for:
                  <ul>
                    <li>The operation of the application and automated calculation of die links,</li>
                    <li>Scientific publications or academic communications relating to computer vision 
                    algorithms or artificial intelligence applied to numismatics.</li>
                  </ul>
                </li>
              </ul>

              <p>No commercial use will be made of the uploaded images.<br/>
              The images will not be resold, used for advertising campaigns, or shared with third 
              parties for profit.</p>

              <h5>4. Privacy</h5>
              <p>Personal data collected (name, email, message) is used solely for the operation of 
              the application, to potentially respond to users or ensure moderation. No personal 
              information will be transmitted to third parties without the user's explicit consent. 
              Each user may request their account to be deleted at any time.</p>

              <h5>5. Responsibilities</h5>
              <p>The application is provided free of charge and as-is, without guarantee of absolute 
              accuracy of results. Users acknowledge that they use the application at their own risk.</p>

              <h5>6. Applicable Law</h5>
              <p>As this application is developed and managed from France, any matters related to its 
              use will be handled according to French law. In case of disagreement, an amicable 
              solution will always be sought first.</p>
            </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={handleCloseTerms}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}            


export default Signup;